export default __webpack_public_path__ + "static/media/approve-0.df9e6329.svg";